import React from 'react';
import { LoadingBackground, LoadingSpinner } from './styles';
import { CircularProgress } from '@material-ui/core';

const Loading: React.FunctionComponent<any> = () => {
  return (
    <LoadingBackground>
      <LoadingSpinner>
        <CircularProgress size={64} />
      </LoadingSpinner>
    </LoadingBackground>
  );
};

export default React.memo(Loading);
